<template>
  <div style="background-image: linear-gradient(#CCE7FF, #fff);margin-top: 64px;">
    <div style="width: 1200px;margin: 0 auto;padding-top: 24px;">
      <div class="information-head">
        <div class="information-head-all">
          <div :class='[changeIndex=="-1" ? "information-head-all-active" : ""]' @click="getAll()">全部资讯</div>
        </div>
        <el-dropdown v-for="(item, index) in typeList" :key="index" @command="handleTwo" style="float: left;width: 13.33%;text-align: center;font-size: 16px;color: #000;cursor: pointer;height: 70px;line-height: 70px;">
          <span :class='[changeIndex==index ? "information-head-all-active" : ""]' @click="changeOne(item.id, index)">
            {{item.name}}
          </span>
          <el-dropdown-menu slot="dropdown" style="width: 100px;text-align: center;" class="new-dropdown-menu" v-if="item.list.length!==0">
            <el-dropdown-item v-for="(i, j) in item.list" :key="j" :command="beforeHandleCommand(index, i.id)">{{i.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="information-content">
        <div class="information-content-left" v-if="list!==undefined&&list.length > 0">
          <div class="information-content-left-module" v-for="(item, index) in list" :key="index" @click="goDetail(item.id)">
            <img :src="item.imgUrl" alt="">
            <div class="information-content-left-module-right">
              <div class="information-content-left-module-right-name">{{item.title}}</div>
              <div class="information-content-left-module-right-title">{{item.abstracts}}</div>
              <div class="information-content-left-module-right-time">
                <div class="information-content-left-module-right-time-mark">{{item.mark}}</div>
                <div class="information-content-left-module-right-time-createTime">{{item.createTime}}</div>
                <div class="information-content-left-module-right-time-editor">{{item.columnName}}</div>
              </div>
            </div>
          </div>
          <div class="information-content-left-btn" @click="getMore()">查看更多</div>
        </div>
        <div v-else class="information-content-left" style="text-align: center;">
          <img src="../assets/searchEmpty.png" style="margin-top: 10%;" alt="">
          <div style="margin-top: 10px;font-size: 14px;color: #918d8d;">暂无更多内容</div>
        </div>
        <div class="information-content-right">
          <img src="../assets/advertisement.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../util/request.js'

export default ({
  data () {
    return {
      typeList: [],
      pageSize: 10,
      pageNum: 1,
      totalPage: '',
      typeId: '',
      oneId: '',
      twoId: '',
      changeIndex: -1,
      list: []
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  mounted () {
    var oneId = this.$route.query.oneId
    var twoId = this.$route.query.twoId
    if (oneId !== undefined) {
      this.oneId = oneId * 1
      this.twoId = twoId * 1
    }
  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: '/web/index/newsTypeList',
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.typeList = res.data.data.typeList
          if (that.oneId !== '') {
            that.typeList.forEach(function (item, index) {
              if (item.id === that.oneId) {
                item.list.forEach(function (i, j) {
                  if (i.id === that.twoId) {
                    that.typeId = i.id
                    that.changeIndex = index
                  }
                })
              }
            })
          }
          that.getList()
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getList () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: '/web/index/newsList',
        data: JSON.stringify({
          pageSize: that.pageSize,
          pageNum: that.pageNum,
          typeId: that.typeId
        })
      }).then(
        (res) => {
          that.list = res.data.data.list
          that.totalPage = res.data.data.totalPage
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getAll () {
      this.typeId = ''
      this.changeIndex = -1
      this.getList()
    },
    changeOne (id, e) {
      this.typeId = id
      this.changeIndex = e
      this.getList()
    },
    beforeHandleCommand (index, id) {
      return {
        id: id,
        index: index
      }
    },
    handleTwo (command) {
      this.typeId = command.id
      this.changeIndex = command.index
      this.getList()
    },
    getMore () {
      var that = this
      if (that.pageNum < that.totalPage) {
        that.pageNum = that.pageNum + 1
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: '/web/index/newsList',
          data: JSON.stringify({
            pageSize: that.pageSize,
            pageNum: that.pageNum,
            typeId: that.typeId
          })
        }).then(
          (res) => {
            var list = res.data.data.list
            list.forEach(function (item, index) {
              that.list.push(item)
            })
            console.log(that.list)
          },
          (err) => {
            that.$message.error(err)
          }
        )
      } else {
        that.$message.success('没有更多了')
      }
    },
    goDetail (id) {
      this.$router.push({
        path: '/informationDetail',
        query: {
          id: id
        }
      })
    }
  }
})
</script>

<style>
.information-head{
  margin-bottom: 14px;
  width: 1200px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  height: 70px;
  line-height: 70px;
  font-size: 16px;
}
.information-head-all{
  float: left;
  text-align: center;
  width: 13.33%;
  cursor: pointer;
}
.information-head-all-active{
  color:#587CF7;
  font-weight: 550;
}
.information-content{
  overflow: hidden;
}
.information-content-left{
  float: left;
  margin-right: 30px;
  width: 870px;
}
.information-content-left-module{
  width: 870px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 14px;
  height: 176px;
  cursor: pointer;
}
.information-content-left-module img{
  width: 242px;
  height: 136px;
  float: left;
  margin-top: 20px;
  margin-left: 21px;
  margin-right: 30px;
}
.information-content-left-module-right{
  float: left;
  margin-top: 20px;
  width: 533px;
}
.information-content-left-module-right-name{
  margin-bottom: 21px;
  color: #595858;
  font-weight: 550;
  font-size: 18px;
  height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.information-content-left-module-right-title{
  color: #747474;
  line-height: 25px;
  height: 50px;
  margin-bottom: 10px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.information-content-left-module-right-time{
  overflow: hidden;
  color: #797979;
  float: right;
  font-size: 16px;
  width: 100%;
}
.information-content-left-module-right-time-mark{
  float: left;
}
.information-content-left-module-right-time-editor{
  float: right;
  margin-right: 15px;
}
.information-content-left-module-right-time-createTime{
  float: right;
}
.information-content-left-btn{
  text-align: center;
  color: #027FFE;
  font-size: 18px;
  margin-top: 52px;
  cursor: pointer;
}
.information-content-right{
  float: right;
}
.information-content-right img{
  width: 300px;
  border-radius: 10px;
}
/* 消除小三角 */
.el-popper[x-placement^=bottom] .popper__arrow{
  border: none;
}
.el-popper[x-placement^=bottom] .popper__arrow::after{
  border: none;
}
/*.el-dropdown-menu__item{*/
/*  padding: 0;*/
/*}*/

.new-dropdown-menu .el-dropdown-menu__item{
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/information.vue